import { render, staticRenderFns } from "./OptionsDropdownComponent.vue?vue&type=template&id=23218896"
import script from "./OptionsDropdownComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsDropdownComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports